export const CURRENT_WORKING_TZ = 'Europe/Warsaw';
